"use client";

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';

export function UtmTracker() {
    const searchParams = useSearchParams();
    const trackedRef = useRef(false);

    useEffect(() => {
        const source = searchParams?.get('utm_source');
        const affiliateRef = searchParams?.get('ref');

        if (affiliateRef?.toUpperCase().startsWith('AFF-')) {
            localStorage.setItem('assignowl_affiliate_ref', affiliateRef);
        }

        if (source) {
            // Check session storage to prevent duplicate tracking on reload/re-render
            const sessionKey = `utm_tracked_${source}`;
            if (sessionStorage.getItem(sessionKey)) {
                return;
            }

            // Mark as tracked immediately
            sessionStorage.setItem(sessionKey, 'true');

            const track = async () => {
                try {
                    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3001/api';
                    await fetch(`${baseUrl}/public/track-utm`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ utm_source: source }),
                    });
                    console.log('UTM source tracked:', source);
                } catch (err) {
                    console.error('UTM Tracking failed', err);
                    // Optional: clear session storage if tracking failed so it retries? 
                    // generally better to fail silently to avoid spamming
                }
            };

            track();
        }
    }, [searchParams]);

    return null;
}
